<template>
  <b-container class="list-clients-wrapper">
    <!-- User Interface controls -->
    <b-card class="shadow-sm">
      <b-row>
        <b-col lg="6" class="my-1">
          <b-form-group
            label="Ordenar"
            label-for="sort-by-select"
            label-cols-sm="3"
            label-size="sm"
            class="mb-0"
            v-slot="{ ariaDescribedby }"
          >
            <b-input-group size="sm">
              <b-form-select
                id="sort-by-select"
                v-model="sortBy"
                :options="sortOptions"
                :aria-describedby="ariaDescribedby"
                class="w-75"
                @change="onSortOrderChange"
              >
              </b-form-select>

              <b-form-select
                v-model="sortDesc"
                :disabled="!sortBy"
                :aria-describedby="ariaDescribedby"
                size="sm"
                class="w-25"
                @change="onSortOrderChange"
              >
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col lg="6" class="my-1">
          <b-form-group
            label="Pesquisar"
            label-for="filter-input"
            label-cols-sm="3"
            label-size="sm"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                id="filter-input"
                v-model="search"
                type="search"
                placeholder="Digite para pesquisar"
                @input="onSearchInput"
              ></b-form-input>

              <b-input-group-append>
                <b-button :disabled="!search" @click="clearSearch">Limpar</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col sm="5" md="6" class="my-1">
          <b-form-group
            label="Registros por página"
            label-for="per-page-select"
            label-cols-sm="6"
            label-cols-md="4"
            label-cols-lg="3"
            label-size="sm"
            class="mb-0"
          >
            <b-form-select
              id="per-page-select"
              v-model="perPage"
              :options="pageOptions"
              size="sm"
              @change="loadCustomers"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col lg="6" class="my-1">
          <b-form-group
            v-model="sortDirection"
            label="Filtrar por"
            description="Deixe todos os filtros desativados para exibir todos os registros"
            label-cols-sm="3"
            label-size="sm"
            class="mb-0"
            v-slot="{ ariaDescribedby }"
          >
            <b-form-checkbox-group
              v-model="filterOn"
              :aria-describedby="ariaDescribedby"
              class="mt-1"
            >
              <b-form-checkbox value="name">Nome</b-form-checkbox>
              <!-- <b-form-checkbox value="age">Idade</b-form-checkbox> -->
              <!-- <b-form-checkbox value="status">Status</b-form-checkbox> -->
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <b-card no-body class="mt-3 shadow-sm">

      <button
        class="bg-transparent w-100 text-center border border-dashed pb-10 text-gray-600"
        v-on:click="createNewCustomer()">
        <i class="fa fa-plus mr-2" aria-hidden="true"></i> Adicionar novo Cliente
      </button>
    </b-card>
    <b-card no-body class="mt-3 shadow-sm">
      <b-table
        :items="items"
        :fields="fields"
        :busy="isLoading"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        stacked="md"
        show-empty
        small
        @sort-changed="onSortChanged"
      >
        <template #table-busy>
          <div class="text-center text-default my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Carregando clientes...</strong>
          </div>
        </template>

        <template #cell(name)="row">
          {{ row.value }}
        </template>

        <template #cell(birthDate)="row">
          <p class="mb-0" v-if="row.value">
            {{ row.value | moment('DD/MM/YYYY') }} - {{ row.value | fromNow(true) }}
          </p>
        </template>

        <template #cell(createdAt)="row">
          <p class="mb-0" v-if="row.value">
            {{ row.value | moment('DD/MM/YYYY') }}
          </p>
        </template>

        <template #cell(status)="row">
          <p class="mb-0" v-if="row.value === 'client'">Cliente</p>
          <p class="mb-0" v-else>Consulta</p>
        </template>

        <template #cell(actions)="row">
          <!-- link to customer -->
          <router-link
            :to="{ name: 'customer', params: { id: row.item.id } }"
            class="ml-2 btn btn-sm btn-outline-primary" title="Abrir" role="button" size="sm"
          >
            <!-- <b-icon icon="eye"></b-icon> -->
            <i class="fa fa-eye"></i>
          </router-link>

          <span class="ml-2 btn btn-sm btn-outline-danger" title="Excluir" role="button" size="sm" @click="deleteCustomer(row.item)">
            <i class="fa fa fa-trash"></i>
          </span>
        </template>

        <template #cell(lastCalcDate)="row">
          <p class="mb-0">
            {{ getLastCalculationDate(row.item) }}
          </p>
        </template>

        <template #cell(calcQtd)="row">
          <p class="mb-0">
            {{ getCalculationQuantity(row.item) }}
          </p>
        </template>
      </b-table>
    </b-card>

    <div class="d-flex justify-content-center mt-3">
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        size="sm"
        class="my-0"
        @change="onPageChange"
      ></b-pagination>
    </div>

    <!-- Info modal -->
    <b-modal :id="infoModal.id" :title="infoModal.title" size="lg" hide-footer @hide="resetInfoModal">
      <b-container>
        <b-col cols="12" align-self="stretch">
          <h2 class="text-left">Cálculo Simples - Servidores Públicos</h2>
          <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Neque porro obcaecati unde,
            maiores adipisci labore nulla deleniti corrupti qui
            maiores adipisci labore nulla deleniti corrupti qui.</p>
        </b-col>
        <router-link
          :to="{ path: 'calculations/new', query: { userId: infoModal.content.id }}"
          class="text-right float-right"
        >
          &#x226A; Iniciar Novo Cálculo
        </router-link>
      </b-container>
      <br />
      <br />
      <b-container>
        <b-col cols="12" align-self="stretch">
          <h2 class="text-left">Cálculo Avançado - Servidores Públicos</h2>
          <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Neque porro obcaecati unde,
            maiores adipisci labore nulla deleniti corrupti qui.</p>
        </b-col>
        <a
          class="text-right float-right"
        >
          &#x226A; Em breve!
        </a>
      </b-container>
    </b-modal>
  </b-container>
</template>

<script>
  import { getCustomers, deleteCustomer, createCustomer } from '@/services/customers'
  import moment from 'moment';
  export default {
  name: 'ListCustomers',
  data() {
    return {
      isLoading: false,
      items: [],
      fields: [
        { key: 'name', label: 'Nome', sortable: true },
        { key: 'birthDate', label: 'Dt. Nascimento', sortable: true },
        { key: 'state', label: 'UF', sortable: true },
        { key: 'createdAt', label: 'Dt. Criação', sortable: true },
        { key: 'lastCalcDate', label: 'Dt. Último Cálculo', sortable: false },
        { key: 'calcQtd', label: 'Qtd. Cálculos', sortable: false },
        { key: 'actions', label: 'Ações', class: 'text-right' }
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 100,
      pageOptions: [5, 10, 15, 50, 100],
      sortBy: '',
      sortDesc: true,
      search: '',
      searchTimeout: null,
      filterOn: [],
      sortDirection: 'asc',
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      }
    }
  },
  computed: {
    sessionUser () { return this.$store.getters.sessionUser },
    sortOptions() {
      return [
        { text: '-- nenhum --', value: '' },
        { text: 'Nome', value: 'name' },
        { text: 'Dt. Nascimento', value: 'birthDate' },
        { text: 'UF', value: 'state' },
        { text: 'Dt. Criação', value: 'createdAt' }
      ]
    }
  },
  mounted() {
    this.loadCustomers();
  },
  methods: {
    async createNewCustomer() {
      const { customer } = await createCustomer();
      this.$router.push({ name: 'customer', params: { id: customer.id }, query: { mode: 'edit' } });
    },
    async loadCustomers() {
      this.isLoading = true;
      try {
        const query = {
          page: this.currentPage,
          limit: this.perPage,
          search: this.search || undefined,
          sortBy: this.sortBy || undefined,
          sortOrder: this.sortDesc ? 'desc' : 'asc'
        };

        const data = await getCustomers(query);
        this.items = data.customers;
        this.totalRows = data.pagination.totalCount;
      } catch (error) {
        console.error('Error loading customers:', error);
        this.$swal.fire('Erro', 'Erro ao carregar clientes', 'error');
      } finally {
        this.isLoading = false;
      }
    },
    async deleteCustomer(item) {
      const result = await this.$swal.fire({
        title: `Remover ${item.name || 'este usuário'}?`,
        text: "Esta ação não poderá ser desfeita!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, pode remover!'
      });

      if (result.isConfirmed) {
        try {
          await deleteCustomer(item.id);
          this.$swal.fire(
            'Pronto!',
            `${item.name || 'O usuário'} foi removido com sucesso!`,
            'success'
          );
          await this.loadCustomers();
        } catch (error) {
          console.error('Error deleting customer:', error);
          this.$swal.fire('Erro', 'Erro ao remover cliente', 'error');
        }
      }
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onSearchInput() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1; 
        this.loadCustomers();
      }, 500);
    },
    clearSearch() {
      this.search = '';
      this.currentPage = 1;
      this.loadCustomers();
    },
    onPageChange(newPage) {
      this.currentPage = newPage;
      this.loadCustomers();
    },
    onSortChanged(sortContext) {
      this.sortBy = sortContext.sortBy || '';
      this.sortDesc = sortContext.sortDesc;
      this.loadCustomers();
    },
    onSortOrderChange() {
      this.loadCustomers();
    },
    getLastCalculationDate(customer) {
      const calculations = customer.calculation;
      
      if (!calculations || calculations.length === 0) {
        return '';
      }
      
      const latestCalculation = calculations.reduce((latest, current) => {
        if (!latest || moment(current.updatedAt).isAfter(latest.updatedAt)) {
          return current;
        }
        return latest;
      }, null);
      
      return latestCalculation ? moment(latestCalculation.updatedAt).format("DD/MM/YYYY") : '';
    },
    getCalculationQuantity(customer) {
      const calculations = customer.calculation;
      return calculations ? calculations.length : 0;
    },
  },
  filters: {
    fromNow(value, withoutSuffix = false) {
      if (!value) return ''
      return moment(value).fromNow(withoutSuffix)
    },
    formatDate(value, format = 'DD/MM/YYYY') {
      if (!value) return ''
      return moment(value).format(format)
    }
  }
}
</script>

<style lang="scss">
.list-clients-wrapper {
  .table.b-table {
    margin-bottom: 0;

    & > thead > tr th {
      border: none;
    }

    td, th {
      vertical-align: middle;
      display: table-cell;
      padding: 1rem 1.5rem;
    }
  }
}
</style>
